/**
 * Labstep
 *
 * @module screens/EntityStateWorkflow/Show
 * @desc EntityStateWorkflow Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { EntityStateWorkflow } from 'labstep-web/models/entity-state-workflow.model';
import { Center } from 'labstep-web/screens/EntityStateWorkflow/Show/Center';
import { ScreensEntityStateWorkflowShowRight as Right } from 'labstep-web/screens/EntityStateWorkflow/Show/Right';
import MasterShow from 'labstep-web/screens/Master/Show';
import type React from 'react';
import type {
  IEntityStateWorkflowShowScreenContainerProps,
  IEntityStateWorkflowShowScreenProps,
} from './types';

export const EntityStateWorkflowShowScreen: React.FC<
  IEntityStateWorkflowShowScreenProps
> = ({ entityStateWorkflow }) => (
  <>
    <DocumentHead title={entityStateWorkflow.name} />
    <MasterShow
      entity={entityStateWorkflow}
      center={<Center entityStateWorkflow={entityStateWorkflow} />}
      right={<Right entityStateWorkflow={entityStateWorkflow} />}
    />
  </>
);

export const EntityStateWorkflowShowScreenContainer: React.FC<
  IEntityStateWorkflowShowScreenContainerProps
> = ({
  match: {
    params: { id },
  },
}) => (
  <ReadOnMountHOC
    type="entities"
    entityName={EntityStateWorkflow.entityName}
    params={{
      get_single: 1,
      is_deleted: 'both',
      id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) => (
      <EntityStateWorkflowShowScreen entityStateWorkflow={entity} />
    )}
  />
);
